import React from "react";
import {Utility} from "@reapptor-apps/reapptor-toolkit";
import {Button, ButtonType, DateInput, Form} from "@reapptor-apps/reapptor-react-components";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import Localizer from "@/localization/Localizer";

import styles from "./Date.module.scss";

export interface IDateProps {
}

interface IDateState {
}

export default class DateStep extends CruiseWizardPage<IDateProps, IDateState> {

    state: IDateState = {
    };

    public async selectAsync(date: Date): Promise<void> {
        this.wizard.date = date;
        this.wizard.departBy = null;
        this.wizard.arriveAt = null;
        await this.nextAsync();
    }

    public renderButtons(): React.ReactNode {
        return (
            <React.Fragment>
                <Button block type={ButtonType.Dark} label={Localizer.cruiseWizardNext} onClick={() => this.nextAsync()}/>

                <Button block type={ButtonType.Light} label={Localizer.cruiseWizardBack} onClick={() => this.prevAsync()}/>
            </React.Fragment>
        )
    }

    public renderContent(): React.ReactNode {
        return (
            <Form className={styles.date}>

                <DateInput required expanded
                           className={styles.item}
                           minDate={Utility.today()}
                           value={this.wizard.date}
                           onChange={(value) => this.selectAsync(value)}
                />

            </Form>
        );
    }
}